/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { IMediaPersonModel, RouteHelper } from "@nf/common";
import { LinkWithLocale } from "../../LinkWithLocale";

import styles from "./MediaPeopleLinks.module.scss";

import CastIcon from "resources/icons/cast.svg";

interface IMediaPeopleLinksProps {
  people: IMediaPersonModel[];
}

export const MediaPeopleLinks = ({ people }: IMediaPeopleLinksProps) => {
  return (
    <>
      {people.map((person) => (
        <LinkWithLocale
          key={person.PersonId}
          href={RouteHelper.goToPerson(person.PersonFullName, person.PersonId)}
        >
          <a className={styles.person}>
            <CastIcon className={styles.icon} />

            {person.PersonFullName}
          </a>
        </LinkWithLocale>
      ))}
    </>
  );
};
